export default __webpack_public_path__ + "static/media/help5.53a50961.svg";